import { render } from "./pptDetail.vue?vue&type=template&id=8d31f322"
import script from "./pptDetail.vue?vue&type=script&lang=js"
export * from "./pptDetail.vue?vue&type=script&lang=js"

import "./pptDetail.vue?vue&type=style&index=0&id=8d31f322&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__